<template>
  <div>
    <OhsHeader :headerMenuList="headerMenuList"></OhsHeader>
    <OhsMain>
      <ul class="article-list">
        <li
          class="article-item"
          v-for="(item, index) in articleList"
          :key="index"
          @click="clickToDetail(index)"
        >
          <div class="item-content">
            <h4>{{ item.title }}</h4>
            <p class="introduction">{{ item.introduction }}</p>
            <div class="item-info">
              <span class="author">
                <img src="aa" alt="" />
                <span>{{ item.author }}</span>
              </span>
              <span class="access-data">
                <span class="like-num">
                  <i class="el-icon-caret-top"></i>
                  <span>{{ item.like }}</span>
                </span>
                <span class="view-num">
                  <i class="el-icon-view"></i>
                  <span>{{ item.viewNum }}</span>
                </span>
                <span class="update-time">{{ item.updateTime }}</span>
              </span>
            </div>
          </div>
        </li>
      </ul>
    </OhsMain>
    <OhsFooter></OhsFooter>
  </div>
</template>

<script>
import OhsHeader from '@/components/layoutBox/OhsHeader.vue';
import OhsMain from '@/components/layoutBox/OhsMain.vue';
import OhsFooter from '@/components/layoutBox/OhsFooter.vue';
import api from '@/assets/api/test.js';
export default {
  name: 'ourSquare',
  components: {
    OhsHeader,
    OhsMain,
    OhsFooter,
  },
  data() {
    return {
      headerMenuList: [
        {
          label: 'all',
          routerPath: '/aaaa',
        },
        {
          label: '软件IT',
          routerPath: '/aasaa',
        },
        {
          label: '硬件工程',
          routerPath: 'aaaa',
        },
        {
          label: '日常生活',
          routerPath: 'aaaa',
        },
      ],
      articleList: [
        {
          title: '空间的给阿斯蒂芬解决',
          author: 'admin',
          introduction: '给分级基金上看看国际化三六零理论框架',
          like: 12,
          viewNum: 500,
          updateTime: '2021-05-06 20:50',
        },
        {
          title: '空间的给阿斯蒂芬解决',
          author: 'admin',
          introduction: '给分级基金上看看国际化三六零理论框架',
          like: 12,
          viewNum: 500,
          updateTime: '2021-05-06 20:50',
        },
        {
          title: '空间的给阿斯蒂芬解决',
          author: 'admin',
          introduction: '给分级基金上看看国际化三六零理论框架',
          like: 12,
          viewNum: 500,
          updateTime: '2021-05-06 20:50',
        },
        {
          title: '空间的给阿斯蒂芬解决',
          author: 'admin',
          introduction: '给分级基金上看看国际化三六零理论框架',
          like: 12,
          viewNum: 500,
          updateTime: '2021-05-06 20:50',
        },
      ],
    };
  },
  methods: {
    clickToDetail(index) {
      api.getTestList({ a: '01' }).then((res) => {
        console.log(res, 'res01');
      });
      console.log(index);
    },
  },
};
</script>

<style lang="scss" scoped>
.article-list {
  max-width: 800px;
  margin: 0 auto;
  padding: 24px;
}
.item-content {
  padding: 20px;
  margin-top: 2px;
  background-color: cornsilk;
  .introduction {
    font-size: 12px;
  }
}
.item-info {
  display: flex;
  justify-content: space-between;
  .author {
    img {
      border-radius: 50%;
    }
  }
  .access-data {
    display: flex;
    & > span {
      padding: 0 8px;
      & > span {
        padding: 2px;
      }
    }
  }
}
</style>
